import qs from 'qs';
import { network } from 'services/network';

export const removeCard = ({ cardId, versionId }: { cardId: number; versionId?: number }) => {
    const queryString = qs.stringify({ cardId, versionId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/removeCard${queryString}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
